<h1 mat-dialog-title class="content-align-center">Resolve game line</h1>
<mat-dialog-content>
  <div>
    @if (confirmation) {
      <div>
        @if (confirmation) {
          <div>You are about to close the game round and set it to {{ formGroup.get('finalResult').value }}.</div>
        }
        @if (isWin()) {
          <span
            >The user will be credited
            <app-form-field-money
              class="display-inline"
              [formGroup]="formGroup"
              [editMode]="false"
              [fieldConfig]="winAmountFieldConfig"></app-form-field-money>
            as part of their verifiable WIN.</span
          >
        }
        @if (!isWin() && isRefund()) {
          <div>
            The user will be credited
            <app-form-field-money
              class="display-inline"
              [editMode]="false"
              [fieldConfig]="nettPriceFieldConfig"
              [data]="data.entity.nettPrice"></app-form-field-money>
            as a refund for the provider error.
          </div>
        }
        @if (!isWin() && !isRefund()) {
          <div>The user will not receive any credit as it was a verified LOSS.</div>
        }
      </div>
    }

    <form [formGroup]="formGroup" [hidden]="confirmation">
      <table>
        <tr>
          <td class="label">Final Result</td>
          <td>
            <mat-form-field>
              <mat-select formControlName="finalResult">
                <mat-option value="WIN">WIN</mat-option>
                <mat-option value="LOST">LOST</mat-option>
              </mat-select>
            </mat-form-field>
          </td>
        </tr>
        <tr [hidden]="!isWin()">
          <td class="label">Win amount</td>
          <td>
            <app-form-field-money
              [formGroup]="formGroup"
              [editMode]="true"
              [fieldConfig]="winAmountFieldConfig"></app-form-field-money>
          </td>
        </tr>
        <tr [hidden]="isWin()">
          <td class="label">Refund stake amount</td>
          <td>
            <mat-checkbox formControlName="refundStakeAmount"></mat-checkbox>
          </td>
        </tr>
      </table>
    </form>
  </div>
  <div mat-dialog-actions class="action-buttons">
    <button
      mat-raised-button
      [color]="'primary'"
      (click)="yes()"
      [disabled]="formGroup && !formGroup.valid"
      data-id="dialogProceedBtn">
      Proceed
    </button>
    <button mat-raised-button [color]="'warn'" (click)="no()" data-id="dialogCencelBtn">Cancel</button>
  </div>
</mat-dialog-content>
